import { render, staticRenderFns } from "./ManageCourse.vue?vue&type=template&id=7a848d4c"
import script from "../../services/teacher/manage-course.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/manage-course.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/teacher/manage-course.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports